import { render } from "./CreateMusicWindow.vue?vue&type=template&id=cca9594c&scoped=true"
import script from "./CreateMusicWindow.vue?vue&type=script&lang=js"
export * from "./CreateMusicWindow.vue?vue&type=script&lang=js"

import "./CreateMusicWindow.vue?vue&type=style&index=0&id=cca9594c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca9594c"]])

export default __exports__